import Vue from 'vue'
import Router from 'vue-router'

import Amenity from "@/components/amenities/Amenity";
import Map from "@/components/amenities/Map";
import Places from "@/components/amenities/Places";
import Travel from "@/components/amenities/Travel";

import Community from "@/components/journey/Community";
import CommunityMap from "@/components/journey/Map";
import Home from "@/components/journey/home/Home";
import Facade from "@/components/journey/home/Facade";
import Package from "@/components/journey/package/Package";
import LocationMap from "@/components/journey/package/LocationMap";
import Selection from "@/components/journey/Selection";
import Spec from "@/components/journey/spec/Spec";
import Favorites from "@/components/favorites/Favorites";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', redirect: '/community'
      // path: '/', redirect: '/community/move-in/home'
      // path: '/', redirect: '/amenities/places'
    },
    {
      path: '/community',
      component: Community,
      children: [
        {
          path: '',
          name: 'selection',
          component: Selection
        },
        {
          path: 'lot',
          name: 'map',
          component: CommunityMap
        },
        {
          path: 'homes',
          name: 'homes',
          component: Home
        },
        {
          path: 'facade',
          name: 'facade',
          component: Facade
        },
        {
          path: 'location',
          name: 'leaflet',
          component: LocationMap
        },
        {
          path: 'move-in',
          name: 'move-in',
          component: Spec
        },
        {
          path: 'move-in/:origin',
          name: 'move-in',
          component: Spec
        },
        {
          path: 'package/:id',
          name: 'package',
          component: Package
        },
        {
          path: 'package/:id/:origin',
          name: 'package',
          component: Package
        },
      ]
    },
    {
      path: '/amenities',
      component: Map,
      children: [
        {
          path: '',
          name: 'amenities',
          component: Amenity
        },
        {
          path: 'places',
          name: 'places',
          component: Places
        },
        {
          path: 'travel',
          name: 'travel',
          component: Travel
        }
      ]
    },
    {
      path: '/favorite',
      name: 'favorite',
      component: Favorites,
    },
    {
      path: '/favorite/:origin',
      name: 'favorite',
      component: Favorites,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router.js